import { TConvertedProductInfo } from '~/app/components/order-converter/converter/DomesticOrderConverter'
import { notEmpty } from '../../utils'
import React from 'react'
import VerticalBar from './VerticalBar'

interface IInfoLineToSpan {
  line: TConvertedProductInfo[number]
}

const InfoLineToSpan: React.FC<IInfoLineToSpan> = ({ line }) => {
  return (
    <React.Fragment>
      {line.filter(notEmpty).map((word, index, array) =>
        typeof word === 'string' ? (
          <React.Fragment key={index}>
            <span>{word}</span>
            {index !== array.length - 1 && <VerticalBar>|</VerticalBar>}
          </React.Fragment>
        ) : (
          <React.Fragment key={index}>
            <span className={word.style}>{word.text}</span>
            {index !== array.length - 1 && <VerticalBar>|</VerticalBar>}
          </React.Fragment>
        )
      )}
    </React.Fragment>
  )
}

export default InfoLineToSpan
